import axios, { AxiosRequestConfig } from "axios";
import React from "react";
import { formatter } from "./num-formatter-alogarithm-by-sylvester-i-e";

import { useExchanges } from "./use-exchanges";

interface AxiosConfigProps {
    method: string,
    url: string,
    headers: { 
        Cookie: string
    }
}

interface LocalCurrency {
    code: string
    country: string
    currency: string
    currency_symbol: string
    value_per_dollar: number
}

interface CurrencyExchange {
    from: string
    value: number
    styli?: string
}

type UseConverterProps = {
    UiForex:(arg:any)=> any
    iforex:(arg:any)=> any
    iforexWS:(arg:any)=> any
    currency_name:string
    liveInfo:LiveProps
}

interface LiveProps {
    connection:any
    currency:any
    location:any
}
const initialCurrency = {
    "connection": {
        "ip": "102.89.32.13",

        "ip_version": "4"
    },
    "currency": {
        "code": [
            "USD"//change to USD as default ignore other details on the containing variable
        ]
    },
    "location": {
        "capital": "Abuja",
        "city": "Lagos",
        "continent": {
            "code": "AF",
            "name": "Africa"
        },
        "country": {
            "alpha_2": "NG",
            "alpha_3": "NGA",
            "dialing_code": [
                "234"
            ],
            "emoji": "🇳🇬",
            "eu_member": false,
            "name": "Nigeria",
            "subdivision": "Lagos",
            "subdivision_id": "LA",
            "zip_code": null
        },
        "latitude": 6.4474,
        "longitude": 3.3903
    },
    "success": true,
    "time": {
        "zone": "Africa/Lagos"
    }
}
/**
 * package: lib in view
 * Author: sylvester Ifeanyi Ekweozor
 * email: sylvester.ekweozor@gmail.com
 * license: MIT (Adopt)
 * 
 * General note: All currencies listed in this app is use by this section
 * as long the administration do not deleted/modify a currency code totally,
 * the programme is good to go.
 * 
 * Each currencies is in their per dollar value OR exchanges rate is given
 * that is => DOLLAR : OTHERCURRENCY as the currency pair
 * 
 * This converter is both UI and hook usage
 */ 
export function useConverter():UseConverterProps {
    const { getExchanges, info } = useExchanges();
    const [liveUserLocation, setLiveUserLocation] = React.useState<typeof initialCurrency>(initialCurrency)

    const liveUserUpdateOnLocation = ()=>{

        // location tracker header
        let config:AxiosRequestConfig<AxiosConfigProps> = {
            method: 'get',
            url: 'https://api.ip2loc.com/1w8VEN6O6ev4PJYMHxUft4kgpL2CiJ4A/detect',
            headers: { 
                'Cookie': '__cfduid=d32807f9c9dfd5f259f54302886a5ae461611396012'
            }
        };

        // location tracker
        axios(config)
        .then(function (response) {
            const liveCurrency:typeof initialCurrency | any = response.data;
            setLiveUserLocation(liveCurrency);
            // console.log("trackerResponse",liveCurrency);
        })
        .catch(function (error) {
            console.log("Error",error);
        });
    }

    React.useEffect(()=>{
        liveUserUpdateOnLocation();
        getExchanges();
    },[]);

    //get the value of user live currency location
    let currency_name = '';
    let live = liveUserLocation.currency ? liveUserLocation : initialCurrency;
    const findUserCurrencyPerDollar = info.HLL ? info.HLL.find(
        (targetCurrency:LocalCurrency)=>{
            // @ts-ignore
            if (targetCurrency.code.toUpperCase() === live.currency.code[0].toUpperCase()){
                currency_name = targetCurrency.code;
                return targetCurrency;
            }
    }) : null;
    
    //get product currency value
    const forex = ({ from = "USD", value = 0}:CurrencyExchange):number =>{
        let formerCurrencyCode = from.toUpperCase();

        const findProductCurrencyPerDollar = info.HLL ? info.HLL.find(
            (targetCurrency:LocalCurrency)=>{
                let laterCurrencyCode = targetCurrency.code.toUpperCase();

                // get the target currency
                if (laterCurrencyCode === formerCurrencyCode){
                    return targetCurrency;
                }
            // Not ready, return the original value
        }) : null;

        // 
        if(!findProductCurrencyPerDollar){
            return 0;
        }

        // given that all currency is in per dollar value or DOLLAR : OTHERCURRENCY - currency pair
        // the conversion formula is 
        // ( product own currency value / it's per dollar value (product ER) ) = total dollar value of product
        // tatal dollar value of product x user currency per dollar value (user ER) 
        // note: user currency per dollar value (user ER)  also the evaluated user curreny amount required to buy it with dollar on aggregate
        //  summary => seller local currency value =to=> dollar value then =to=> user currency value
        let dollar_value = value / findProductCurrencyPerDollar?.value_per_dollar;
        let user_currency_value = dollar_value * findUserCurrencyPerDollar?.value_per_dollar;
        
        return user_currency_value;
    }
    // console.log("forex()",forex({ to:"NGN", value:1500 }));

    //with UI
    function UiForex({ from, value, styli = "" }:CurrencyExchange) {
        let convertedValue = forex({ from, value });
        let approx_two_decimal = convertedValue.toFixed(2);
        let formatedValue = formatter(approx_two_decimal);
        let currency_symbol = findUserCurrencyPerDollar?.currency_symbol ?? "$"; //initialCurrency
        return (
            <div className={styli}>{currency_symbol+formatedValue}</div>
        )
    }
    
    // without UI as Hook
    function iforex({ from, value}:CurrencyExchange) {
        let convertedValue = forex({ from, value });
        let approx_two_decimal = convertedValue.toFixed(2);
        let formatedValue = formatter(approx_two_decimal);
        let currency_symbol = findUserCurrencyPerDollar?.currency_symbol ?? "$"; //initialCurrency
        return currency_symbol+formatedValue
    }

    // with pure number as Hook without symbol
    function iforexWS({ from, value}:CurrencyExchange) {
        let convertedValue = forex({ from, value });
        return convertedValue
    }

    return {
        UiForex,
        iforex,
        iforexWS,
        currency_name,
        liveInfo: liveUserLocation ?? initialCurrency,//init is to avoid network error breaking in if occurred  
    }

}
